const { VUE_APP_HOST, VUE_APP_ENVKEY } = process.env;
const MODE = {
	dev: {
		env: 'dev',
		host: 'https://dev.tuwenzhibo.com',
		surveyHost: 'https://dev.tuwenzhibo.com',
		ssoPath: 'https://logindev.ourwill.cn',
		apipath: '/srv',
		surveyApipath: '/shop/api',
		uploadsever: '/upload/one',
		apiPath: 'https://dev.tuwenzhibo.com',
		Host: VUE_APP_HOST,
		uploadHost: 'https://upload.inmuu.com/' + VUE_APP_ENVKEY,
	},
	beta: {
		env: 'beta',
		host: location.origin,
		surveyHost: location.origin,
		ssoPath: 'https://logindev.ourwill.cn',
		apipath: '/srv',
		surveyApipath: '/shop/api',
		uploadsever: '/upload/one',
		apiPath: location.origin,
		Host: VUE_APP_HOST,
		uploadHost: 'https://upload.inmuu.com/' + VUE_APP_ENVKEY,
	},
	release: {
		env: 'release',
		host: location.origin,
		surveyHost: location.origin,
		ssoPath: 'https://sso.inmuu.com',
		apipath: '/srv',
		surveyApipath: '/shop/api',
		uploadsever: '/upload/one',
		apiPath: location.origin,
		Host: VUE_APP_HOST,
		uploadHost: 'https://upload.inmuu.com/' + VUE_APP_ENVKEY,
	},
	business_beta: {
		env: 'business',
		host: 'http://saas.inmuu.com',
		surveyHost: 'http://saas.inmuu.com/beta',
		ssoPath: 'https://sso.inmuu.com',
		surveyApipath: '/beta/srv',
		apipath: '/beta/srv',
		uploadsever: '/api/fileStorage/one',
		apiPath: 'http://saas.inmuu.com',
		Host: VUE_APP_HOST,
		uploadHost: 'https://upload.inmuu.com/' + VUE_APP_ENVKEY,
	},
	business_v1: {
		env: 'business',
		host: location.origin,
		surveyHost: location.origin + '/v1',
		ssoPath: 'https://sso.inmuu.com',
		surveyApipath: '/v1/srv',
		apipath: '/v1/srv',
		uploadsever: '/api/fileStorage/one',
		apiPath: location.origin,
		Host: VUE_APP_HOST,
		uploadHost: 'https://upload.inmuu.com/' + VUE_APP_ENVKEY,
	},
};

const conf = MODE[process.env.VUE_APP_ENV];

if (process.env.NODE_ENV == 'development') {
	conf._host = `${conf.host}`;
	conf.host = `/remote-${conf.env}`;
	conf.apiPath = `/remote-${conf.env}`;
}

conf.ssrUrl = 'https://ssr.ourwill.cn';

export default conf;
